import React, { useMemo } from "react";
import _map from "lodash/map";
import _filter from "lodash/filter";
import _isEmpty from "lodash/isEmpty";
import { Input, Row, Col, Tooltip, Badge } from 'antd';
import { InfoCircleFilled, SearchOutlined } from '@ant-design/icons';
import { SvgExhibitorList, SvgFilter } from "../common/SvgIcons";
import CustomScrollbars from '../../utils/CustomScrollbars'

function ExhibitorList({
    filterChangeHandler,
    setOnlySponser,
    highlightBooth,
    openCompanyPopup,
    advancedSearch,
    customThemeStyle,
    calculatedHeight,
    handleCardContent = () => { },
    ...props
}) {
    const drawerState = window.innerWidth < 1024;
    const renderFilterIcon = () => {
        let el = <div onClick={() => handleCardContent('advanced_search')} >
            <SvgFilter className="exhibitor-icon-size gx-pointer" color={customThemeStyle.primary_color} />
        </div>

        if (!_isEmpty(advancedSearch)) {
            el = <Badge count={<InfoCircleFilled style={{ color: '#faad14', fontSize: "18px" }} />}>
                {el}
            </Badge>
        }
        return el;
    }
    return (
        <div>
            <div className="row">
                <div className="col-12 exhibitor-search-header gx-my-5 gx-mx-5 gx-mb-2 gx-px-2 gx-d-flex" style={{ justifyContent: 'space-between' }}>
                    <div><h1 className='app-text-color'><b>Exhibitor List</b></h1></div>
                    <SvgExhibitorList className="icon-size" color={customThemeStyle.primary_color} />
                </div>
                <div className="col-12 gx-d-flex justify-content-xl-between gx-mt-5 gx-mx-5 gx-mb-2 gx-pr-3" style={{ justifyContent: 'space-between' }}>
                    <Input placeholder='Enter Search Term ...' size="large" className="form-control gx-algolia-search-box search-filter-box" onChange={filterChangeHandler} prefix={<SearchOutlined className='app-text-color' />} />
                    {(props.tagCategories && props.tagCategories.length) && <Tooltip title="Filter">
                        {renderFilterIcon()}
                    </Tooltip>}
                </div>
            </div>
            <div className='gx-my-4 gx-px-0 gx-mx-1'>
                <Row className="exhibitor-list-header gx-mb-3 gx-px-5">
                    <Col span={drawerState ? 15 : 17}>
                        <div className="text-left gx-pointer" ><h4 className="exhibitor-list-header-text">Company Name</h4></div>
                    </Col>
                    <Col span={drawerState ? 9 : 7}>
                        <div className="text-right gx-pointer" ><h4 className="exhibitor-list-header-text">Booth</h4></div>
                    </Col>
                </Row>
                <div style={{ height: drawerState ? calculatedHeight : calculatedHeight-210 }}>
                <CustomScrollbars style={{ height: 'inherit' }}>
                    <div className="exhibitor-list-row-container gx-px-5">
                        {props.sortedBooths.map((booth_id, inx) => {
                            let booth = props.booths[booth_id]['booth_data'];
                            if (booth.hasOwnProperty('CompID') && booth['CompID'] != null && booth['CompID'] != 999999) {
                                let company = props.exhibitors[booth['CompID']];
                                if (!company) { return null; }
                                return (
                                    <Row className="exhibitor-list-row gx-pointer gx-mb-3 gx-px-2" key={booth_id} >
                                        <Col span={drawerState ? 16 : 18} className="gx-pl-3 exhibitor-list-col exhibitor-list-col-hover" style={{alignSelf:"center"}} onClick={(e) => { openCompanyPopup(booth_id) }}>
                                            <div className="text-left gx-pl-4">
                                                <h4 className="exhibitor-list-text">
                                                    <span>{company.Companyname}</span> {company.sponsor && (<span className="label label-info">Sponsor</span>)}
                                                </h4>
                                            </div>
                                        </Col>
                                        <Col span={drawerState ? 8 : 6} className="exhibitor-list-col gx-pl-1" style={{width:'fit-content'}}>
                                            <div className="gx-text-right">
                                                <h4 className="exhibitor-list-text">
                                                    <span onClick={() => { highlightBooth(booth_id) }}><a className="app-text-color">{booth.BoothNo}</a></span>
                                                </h4>
                                            </div>
                                        </Col>
                                    </Row>
                                );
                            }
                        })}
                        {_isEmpty(props.sortedBooths) && <div className='gx-m-2 gx-text-center app-text-color'>No results found</div>}
                    </div>
                </CustomScrollbars>
                </div>
            </div>
        </div>
    )
}

export default ExhibitorList;